<template>
  <div class="card">
    <results-card
      :id="id"
      :title="title"
      :room-level="true"
      :abs-card="true"
      :main-img="mainImg"
      :refundability="refundability"
      :small-img-gallery="smallImgGallery"
      :facilities="facilitiesList"
      :price="totalPrice"
      :purple-price="amenitiesAdded"
    />
    <div class="amenities-title tooltip">
      <span>Choose Extras</span>
      <span
        class="tooltip"
        title="Extra options available for this rooms"
      />
    </div>
    <div class="amenities-list">
      <div
        v-for="item in computedAmenities"
        :key="`room-${id}-amenity-${item.id}`"
        class="amenities-item"
      >
        <div
          class="img"
          @click="$emit('trigger-modal');"
        >
          <img
            :src="item.imgUrl"
            :alt="item.title"
          >
        </div>
        <div class="info">
          <div
            class="title"
            @click="$emit('trigger-modal');"
          >
            {{ item.title }}
          </div>
          <div class="description">
            {{ item.description }}
          </div>

          <multiselect
            v-if="item.options && item.options.length"
            v-model="item.selectedPrice"
            class="select-blue"
            track-by="name"
            label="name"
            :searchable="false"
            :allow-empty="false"
            :show-labels="false"
            :options="item.options"
            :custom-label="({ name, price }) => `${name} (+${currency}${price})`"
            @input="handleAmenityOptionSelect(item)"
          />
          <button
            :class="{ selected: item.selected }"
            @click="handleAmenitySelect(item);"
          >
            {{ '+' + currency + (item.selectedPrice.price || item.selectedPrice) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResultsCard from './SearchResultsCard';

export default {
  name: 'abs-room-card',
  components: {
    ResultsCard,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    mainImg: {
      type: String,
      default: null,
    },
    smallImgGallery: {
      type: Array,
      default: null,
    },
    refundability: {
      type: String,
      default: null,
    },
    price: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '$',
    },
    facilitiesList: {
      type: Array,
      default: null,
    },
    amenitiesList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      totalPrice: this.price,
      amenitiesAdded: false,
    };
  },
  computed: {
    computedAmenities() {
      const list = [...this.amenitiesList];
      list.forEach(item => {
        item.selected = false;
        item.selectedPrice = item.price ? item.price : item.options[0];
      });
      return list;
    },
  },
  watch: {
    totalPrice() {
      if (this.totalPrice > this.price) {
        this.amenitiesAdded = true;
      } else {
        this.amenitiesAdded = false;
      }
    },
  },
  methods: {
    calculatePrice() {
      let totalPrice = this.price;
      this.computedAmenities.forEach(item => {
        if (item.selected) {
          totalPrice += parseInt(item.selectedPrice.price || item.selectedPrice);
        }
      });
      this.totalPrice = totalPrice;
    },
    handleAmenitySelect(item) {
      item.selected = !item.selected;
      this.calculatePrice();
    },
    handleAmenityOptionSelect(item) {
      item.selected = true;
      this.calculatePrice();
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  padding: 16px;
  border-radius: 4px;
  text-align: left;
  font-size: 13px;
  color: #6e7c91;
  background-color: #fff;
  box-shadow: 0 6px 25px 4px rgba(114, 132, 160, 0.18);
}

.amenities {

  &-title {
    margin-top: 16px;
    color: #6e7c91;
    font-size: 15px;
    font-weight: 700;

    .tooltip {
      display: inline-block;
      margin-left: 7px;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      background-image: url('../assets/icons/icon-info.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      opacity: .34;
    }
  }

  &-item {
    display: flex;
    padding: 16px 0;
      border-bottom: 1px solid #edf1f6;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .img {
      cursor: pointer;
      flex-shrink: 0;
      width: 125px;
      height: 125px;
      margin-right: 16px;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: flex-start;

      .title {
        cursor: pointer;
        margin-bottom: 12px;
        color: #32325a;
        font-size: 17px;
        font-weight: 700;
        .no-touchevents &:hover {text-decoration: underline;}
        &:active {text-decoration: underline;}
      }

      .description {
        margin-bottom: 24px;
        line-height: 1.25;
        color: #6e7c91;
        font-size: 15px;
        font-weight: 500;
      }

      .select-blue {
        display: inline-block;
        vertical-align: middle;
        min-width: 205px;
        width: auto;
        & + * {margin-top: 12px;}
      }

      button {
        border: none;
        border-radius: 3px;
        background-color: #56b282;
        padding: 8px 12px;
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        &:focus {outline: none;}

        &.selected {
          padding-left: 28px;
          background-color: #6d61fe;
          background-image: url('../assets/icons/icon-check.png');
          background-repeat: no-repeat;
          background-size: 14px auto;
          background-position: 10px center;
        }
      }
    }
  }
}
</style>
